<template>
  <div ref="navWrap" class="tabs" :class="{ 'tabs-track': showTrack }">
    <div
      v-for="(item, index) in tabList"
      :key="item.label"
      class="tab-item"
      :style="{
        color: index === activeIndex ? activeColor : usuallyColor,
        fontSize: fontSize
      }"
      @click="changeTab(index)"
    >
      <slot name="content" :tab="item">
        {{ item.label }}
      </slot>
    </div>
    <div ref="tabLine" class="tab-line" :style="barStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'TabSwitch',

  props: {
    tabList: {
      type: Array,
      required: true
    },

    defaultTabIndex: {
      type: [String, Number],
      default: 0
    },

    activeColor: {
      type: String,
      default: '#1890ff'
    },

    usuallyColor: {
      type: String,
      default: '#fff'
    },

    fontSize: {
      type: String,
      default: '14px'
    },

    // 是否显示tab滑动轨道，即底部边线
    showTrack: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      activeIndex: 0,
      barWidth: 0,
      barOffset: 0
    }
  },

  computed: {
    barStyle() {
      return {
        width: `${this.barWidth}px`,
        transform: `translateX(${this.barOffset}px)`,
        transition: 'transform .3s',
        background: this.activeColor
      }
    }
  },

  watch: {
    activeIndex() {
      this.updateBar()
    },

    defaultTabIndex: {
      handler(val) {
        if (val > -1) {
          this.changeTab(val)
        }
      },
      immediate: true
    }
  },

  mounted() {
    this.updateBar()
  },

  methods: {
    changeTab(index) {
      this.activeIndex = index

      this.$emit('tabChange', index)
    },

    updateBar() {
      this.$nextTick(() => {
        // 当前选中的activeKey下标
        const index = this.tabList.findIndex(
          (tab, index) => index === this.activeIndex
        )
        // 获取navWrap元素下的所有tab的元素
        const elemTabs = this.$refs.navWrap.querySelectorAll('.tab-item')
        // 获取当前选中的元素
        const elemTab = elemTabs[index]
        this.barWidth = elemTab ? elemTab.offsetWidth : 0
        // 计算需要移动的距离，当index>0时进行累加
        if (index > 0) {
          this.barOffset = elemTab.offsetLeft
        } else {
          this.barOffset = 0
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  align-items: center;
  position: relative;

  &.tabs-track {
    border-bottom: 1px solid $info-fourth-color;
  }

  .tab-item {
    //min-width: 80px;
    font-size: 16px;
    color: #fff;
    padding: 8px 0;
    text-align: center;
    cursor: pointer;
    letter-spacing: 0.1em;

    &:not(:last-child) {
      margin-right: 48px;
    }
  }

  .tab-line {
    width: 80px;
    position: absolute;
    height: 2px;
    bottom: 0px;
    left: 0px;
    //background: #1890ff;
  }
}
</style>
